import { Typography } from "@material-ui/core";

export const Loading = () => {
    return <Typography variant="h6">...</Typography>
}